import React, { useState } from "react";
import "./view.scss";

import {
  ClearOutlined,
  DeleteOutlined,
  EditOutlined,
  QuestionCircleOutlined,
  UnorderedListOutlined,
} from "@ant-design/icons";
import { useHistory } from "react-router-dom";
import {
  COMMON_CONSTANT,
  KEY,
  lang,
  TAB_VIDEO,
} from "../../constants/common.const";
import { VideoApi } from "../../api/backend/video";
import Loading from "../../component/Desktop/loading/loading";
import { Modal } from "antd";
import { handleCatchError, showMessage } from "../../constants/utils";
import { useSelector } from "react-redux";
import RoleHeadOffice from "../../routers/roles/roles.const";
const VideoAction = ({ videoId, callbackDelete ,isDelete,isEdit,isVideoPlayList,callBackAddPlayList}) => {
  const { userName, roleKey ,isLeader} = useSelector((state) => state.auth);
  const { currentTab } = useSelector((state) => state.video);
  const history = useHistory();
  let [showLoading, setShowLoading] = useState(false);
  let openLoadingSpinner = () => {
    setShowLoading(true);
  };

  let closeLoadingSpinner = () => {
    setShowLoading(false);
  };
  const isShowEditDetele = roleKey == 1 || roleKey == 2 || roleKey == 3;
  const showMessageDeleteConfirm = (rowData) => {
    // Action del
    const funcDel = async () => {
      openLoadingSpinner();

      // API Del
      try {
        // Close warning
        Modal.destroyAll();

        await VideoApi.deleteManualVideo(videoId);
        // API Search

        // Open success
        showMessage(KEY.INFO, COMMON_CONSTANT.BOM_C004, () => {
          if (callbackDelete) {
            callbackDelete(videoId);
          } else {
            history.push("/VideoManagement");
          }
        });
      } catch (ex) {
        handleCatchError(ex);
      }
      closeLoadingSpinner();
    };

    Modal.confirm({
      icon: <QuestionCircleOutlined />,
      centered: true,
      title: lang.DELETE,
      content: "削除してもよろしいですか？",
      okText: lang.OK,
      cancelText: lang.CANCEL,
      onOk: funcDel,
      zIndex: 10000,
    });
  };
  const onSave = async () => {
    try {
      openLoadingSpinner();
      await VideoApi.createVideoPlaylist({
        videoId,
        owner: userName,
      });

      showMessage(KEY.INFO, "動画をマイプレイリストに追加しました。");
      if(callBackAddPlayList){
        callBackAddPlayList(videoId)
      }
    } catch (error) {
      handleCatchError(error);
    } finally {
      closeLoadingSpinner();
    }
  };
  const handleAddPlayList = () => {
    Modal.confirm({
      zIndex: 10000,
      centered: true,
      title: lang.CONFIRM,
      content: "動画をマイプレイリストに追加してよろしいですか。",
      okText: lang.OK,
      cancelText: lang.CANCEL,
      icon: <QuestionCircleOutlined />,
      onOk: () => {
        onSave();
      },
      onCancel: () => {},
    });
  };

  const onDeletePlayList = async () => {
    try {
      openLoadingSpinner();
      await VideoApi.deletePlayList({
        id:videoId,
        userName: userName,
      });

      showMessage(KEY.INFO, "動画をマイプレイリストから削除しました。",() => {
        if(callbackDelete){
          callbackDelete(videoId);
        }
      });
    } catch (error) {
      handleCatchError(error);
    } finally {
      closeLoadingSpinner();
    }
  };
  const handleDeletePlayList = () => {
    Modal.confirm({
      zIndex: 10000,
      centered: true,
      title: lang.CONFIRM,
      content: "動画をマイプレイリストから削除してよろしいですか。",
      okText: lang.OK,
      cancelText: lang.CANCEL,
      icon: <QuestionCircleOutlined />,
      onOk: () => {
        onDeletePlayList();
      },
      onCancel: () => {},
    });
  };
  return (
    <div style={{minWidth:150}}>
      <ul className="video-popover-options">
        {isEdit && (
          <li
            onClick={() => history.push("/VideoManagement/Edit/" + videoId)}
            className="video-popover-item"
          >
            <EditOutlined
              style={{
                marginRight: 5,
              }}
            />
            編集
          </li>
        )}
        {isDelete && (
          <li onClick={showMessageDeleteConfirm} className="video-popover-item">
            <DeleteOutlined
              style={{
                marginRight: 5,
              }}
            />
            削除
          </li>
        )}
        {(currentTab != TAB_VIDEO.PLAYLIST && !isVideoPlayList) && (
          <li onClick={handleAddPlayList} className="video-popover-item">
            <UnorderedListOutlined
              style={{
                marginRight: 5,
              }}
            />
            マイプレイリスト追加
          </li>
        )}
        {currentTab == TAB_VIDEO.PLAYLIST && (
          <li onClick={handleDeletePlayList} className="video-popover-item">
            <ClearOutlined 
              style={{
                marginRight: 5,
              }}
            />
            マイプレイリスト削除
          </li>
        )}
      </ul>
      <Loading show={showLoading}></Loading>
    </div>
  );
};

export default VideoAction;
